/**
 * 객체 설정 > 프로토콜 Store
 *
 * @since 2018-06-12
 * @author kdydesign.kim
 */

// TAMS
import { CmApiPrefix as cmApiPrefix } from 'utils'

export const state = () => ({
  protocolData: [],
  protocolList: [],
  selectedData: void 0
})

export const mutations = {
  // 프로토콜 목록 초기화
  resetProtocolList (state) {
    state.protocolList = []
  },

  // 프로토콜 선택
  selectProtocolData (state, data) {
    state.selectedData = data
  },

  // 프로토콜 조회
  getProtocolList (state, data) {
    let protocolList = _.cloneDeep(state.protocolList)
    let protocolData = _.cloneDeep(state.protocolData)

    if (_.isArray(data)) {
      protocolData = data
      protocolList = []

      _.forEach(data, (value) => {
        // TAMS
        protocolList.push({
          label: value.prtc_obj_uname,
          value: value.prtc_obj_id,
          // TAMS
          prtc: value.prtc_obj_prtc
        })
      })
    } else if (_.isPlainObject(data)) {
      protocolData.push(data)

      // TAMS
      protocolList.push({
        label: data.prtc_obj_uname,
        value: data.prtc_obj_id,
        // TAMS
        prtc: data.prtc_obj_prtc
      })
    }

    state.protocolList = Object.freeze(protocolList)
    state.protocolData = Object.freeze(protocolData)
  },

  // 프로토콜 삭제
  deleteProtocol (state, data) {
    const protocolList = _.cloneDeep(state.protocolList)
    const protocolData = _.cloneDeep(state.protocolData)

    const protocolListIndex = _.findIndex(state.protocolList, {value: data})
    const protocolDataIndex = _.findIndex(state.protocolData, {prtc_obj_id: data})

    protocolList.splice(protocolListIndex, 1)
    protocolData.splice(protocolDataIndex, 1)

    state.protocolList = Object.freeze(protocolList)
    state.protocolData = Object.freeze(protocolData)
  }
}

export const actions = {
  // 프로토콜 목록 조회
  async getProtocolList ({commit, state}, {loadingShow = true, loadingHide = true} = {}) {
    // TAMS
    const
      prtcObjId = 0, // 프로토콜 객체 아이디 (0: 전체 조회)
      url = `objects/prtc/${prtcObjId}`
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/${url}`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('getProtocolList', result)
    }
  },

  // 프로토콜 저장
  async saveProtocol ({commit, state, dispatch}, protocols) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      // TAMS
      const sendData = protocols
      sendData.prtc_obj_desc = _.isUndefined(sendData.prtc_obj_desc) ? '' : sendData.prtc_obj_desc
      res = await this.$axios.$post(`${cmApiPrefix}/objects/prtc`, sendData)

      if (res.code === 'ok') {
        dispatch('common/common/setIsChanged', true, {root: true})
        // TAMS 미사용, 전체 갱신
        // commit('getProtocolList', result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },

  // 프로토콜 삭제
  async deleteProtocol ({commit, state, dispatch}) {
    // TAMS
    let prtcObjIdList = []
    const selectedData = _.cloneDeep(state.selectedData)
    if (_.get(selectedData, ['length'], 0) > 0) {
      prtcObjIdList = _.map(selectedData, item => item.prtc_obj_id)
    } else {
      prtcObjIdList = [selectedData.prtc_obj_id]
    }
    const sendData = {
      prtc_obj_id_list: JSON.stringify(prtcObjIdList)
    }
    const res = await this.$axios.$put(`${cmApiPrefix}/objects/prtc/multi`, sendData)

    if (res.code === 'ok') {
      dispatch('common/common/setIsChanged', true, {root: true})
      // TAMS 미사용, 전체 갱신
      // commit('deleteProtocol', protocolId)
      // commit('getProtocolList', state.protocolData)
    }
    // TAMS
    return res
  }
}

export const getters = {}

export const strict = false
